var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMachineDirectory = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 6.055V3L12 7.434L5.5 3V6.055L2 5.317V19.34L11.5 21.34L11.8 21.4035L12 21.434L12.2 21.4035L12.5 21.34L22 19.34V5.317L18.5 6.055ZM17.5 4.867V16.667L12.5 20V8.34L17.5 4.867ZM11.5 8.34V20L6.5 16.667V4.867L11.5 8.34ZM3 18.5285V6.5505L5.5 7.0765V17.2015L9.5625 19.91L3 18.5285ZM21 18.5285L14.4375 19.91L18.5 17.2015V7.0765L21 6.5505V18.5285Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMachineDirectory);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/machine-directory.ca1af27f0b95e2753005a6c085dd7deb.svg";